import styled from 'styled-components';

import { CTA_CLASS } from 'core/components/Cta/Cta.style';

export const Wrapper = styled.div`
	.${CTA_CLASS} {
		padding: 0;
		margin: 5px 0 20px;
	}
`;

export const CloseButton = styled.div`
	.${CTA_CLASS} {
		margin: 0;
	}
`;
